import React from 'react';
import { MAX_APPLICABLE_INTAKE_FILTERS } from './policy';

import intakeAppliedFiltersCss  from './IntakeQuestionFilterToolTip.scss';

const IntakeQuestionFilterToolTip = () => {

  const maxFilterLimitMessage =
    (`Only ${MAX_APPLICABLE_INTAKE_FILTERS} filters can be used at the same time. `
     + `Deselect a filter to add a new one.`);


  return (
      <div role="tooltip"
           className={ intakeAppliedFiltersCss.toolTip } >
              { maxFilterLimitMessage }
      </div>
  );
};

export default IntakeQuestionFilterToolTip
